/* eslint-disable max-len */
// /* eslint-disable max-len */
import React,{useState,useEffect,useContext} from 'react'
import { validateEmail } from '../../../../CommonMethods/EmailValidator';
import ErrorMessage from '../../../../components/ErrorMessage';
import GlobalContext from '../../../../components/Context/GloablContext';
import Loader from '../../../../components/Loader';
import {motion} from 'framer-motion'
import BannerImage from '../../../../components/BannerImage';
import AnimatedPage from '../../../../components/Animation/AnimatedPage';
import { dataService } from '../../../../services/data.services';
import { useDispatch } from 'react-redux';
import { resetState } from '../../../../redux/systemConfigSlice';
import HelpGuideModal from '../../../../components/HelpGuideModal';
import {useGetHelpGuideProviderLoginQuery} from '../../../../slices/patientSlice'

export default function SignIn({
    handleLoginCredentilas,
    emptyError,
    setEmptyError,
    email,
    password,
    error,
    seterror,
    handleLogin,
    loading,
    loginError,
    setIsForgotPassword
}
) {
    const [type, settype] = useState(true)
    const dispatch = useDispatch()
    const [invalidEmail, setInvalidEmail] = useState(false)
    const [invalidPassword,setInvalidPassword]=useState(false)
    const { setToastErrorMessage,editSocket,setEditSocket } = useContext(GlobalContext)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [queryParams, setQueryParams] = useState(`type=monitor-login`)
    const { data,status:helpguidestatus} = useGetHelpGuideProviderLoginQuery(queryParams);

    function handleEmailChange(enteredEmail) {
        setInvalidEmail(validateEmail(enteredEmail));

    }
    const handleShowPassword = () => {
        settype(!type);
    }

    useEffect(()=>{
        dispatch(resetState())
        const status=sessionStorage.getItem('custom-status')
        const showDuplicateSessionLogout = sessionStorage.getItem('showDuplicateSessionLogout');
        const showLogoutToast = localStorage.getItem('showLogoutToast');
        const isThisTabInitiatingLogout = !!window?.isLoggingOutRef?.current;
        if (showDuplicateSessionLogout) {
            setToastErrorMessage('You have been logged out due to another login session');
            sessionStorage.removeItem('showDuplicateSessionLogout');
        } else if (showLogoutToast) {
            // If this tab initiated logout itself, ignore cross-tab toast even if another tab set the flag.
            if (!isThisTabInitiatingLogout) {
                setToastErrorMessage('You have been logged out due to logout in another tab');
            }
            localStorage.removeItem('showLogoutToast');
        }
        
        if(status==='inactive'&&status!==undefined){
            setToastErrorMessage("You've been logged out, your account is deactivated or session timed out. Please log in again.")
        }
        sessionStorage.clear()
       
    },[])
    
    return (
        <>
            <AnimatedPage>
                <div className='w-[35%] 2xl:w-[30%] pl-[30px] 2xl:pl-0'>
            
                    <div className='w-[290px] xl:[300px] 2xl:w-[330px] flex flex-col justify-center items-center h-screen'>
                        <div className='w-full'>
                            <img src="/images/Arcm_login_logo.png" alt="Banner-Img" className='w-fit h-fit mx-auto' loading='lazy' decoding='async'/>
                            <h1 className='mt-6 text-[36px] font-normal text-[#000] text-center'>Login</h1>
                            <div className='flex justify-center items-center'>
                                <h1 className='text-lg font-normal text-[#000] text-center'>Please enter your details to login </h1>
                                <span onClick={() => setHelpGuideModel(true)} className='ml-0.5 cursor-pointer'>
                                    <img src="/images/info.png" alt="icon" loading="lazy" decoding="async" />
                                </span> 
                            </div>
                            <form action="" className='mt-8' onSubmit={(e)=>handleLogin(e)}>
                                <div className='flex flex-col'>
                                    <label htmlFor='email' className='text-xs font-semibold text-[#000] pb-1.5'>Username</label>
                                    {/* border-[#D3454D] */}
                                    <input type="text" 
                                        id='userName' 
                                        autoComplete="off"

                                        value={email}
                                        onChange={(e)=>{
                                            handleLoginCredentilas('email',e.target.value)
                                            handleEmailChange(e.target.value)
                                        }} 
                                        onFocus={()=>{
                                            seterror(false)
                                            setToastErrorMessage("")
                                            setInvalidEmail(false)
                                            setEmptyError(false)
                                        }}
                                        style={{
                                            border: `1px solid ${error || (emptyError && email.trim() === '') ? '#C81720' : '#C5C9DA'}`,
                                        }}                                        className='border border-[#C5C9DA] rounded-lg px-3.5 py-[11px] text-sm font-normal outline-0
                                    text-[#000B17] w-full placeholder:text-[#52555D] outline-none focus:border-[#339D9E] 
                                    focus:shadow-s1' placeholder='Enter username' />
                                </div>
                                <div className='flex flex-col mt-4'>
                                    <label htmlFor='Username' className='text-xs font-semibold text-[#000] pb-1.5'>Password</label>
                                    <div className='relative'>
                                        <input type={type ? "password" : "text"} id='passWord' 
                                            value={password}
                                            onFocus={()=>{
                                                seterror(false)
                                                setToastErrorMessage("")
                                                setInvalidPassword(false)
                                                setEmptyError(false)
                                            }} 
                                            style={{border:`1px solid ${error||invalidPassword||(emptyError&&password.trim()==="")?'#C81720':'#C5C9DA'}`}}
                                            onChange={(e)=>{
                                                handleLoginCredentilas('password',e.target.value)}}  
                                            className='border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm 
                                        font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none
                                        focus:border-[#339D9E] focus:shadow-s1' 
                                            autoComplete='off' placeholder='Enter password' />
                                        <button type='button' className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                            <span onClick={() =>handleShowPassword()} className='text-xs font-semibold text-[#008586]'>{type ? "SHOW" : "HIDE"}</span>
                                            <span className='text-xs font-semibold text-[#008586] hidden'>HIDE</span>
                                        </button>
                                    </div>
                                </div>
                                {error && <ErrorMessage error  message={loginError}/>}
                                {/* <p className='text-sm font-normal text-[#F04438] mt-4'>Incorrect username or password</p> */}
                                <button type='button' disabled={loading} onClick={() => setIsForgotPassword(true)} id="forgot" className='text-xs font-semibold text-[#008586] mt-3'>Forgot password</button>
                                <button type='submit'
                                    id="login"
                                    disabled={loading}
                                    className='w-full mt-8 py-2.5 px-2 text-lg font-semibold text-[#fff] rounded-[16px] 
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]'>
                                    {!loading?'Login':<span>{<Loader/>}</span>}
                                </button>
                            </form>
                        </div>
                    
                    </div>
            
                </div>
            </AnimatedPage>
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                helpguidestatus={helpguidestatus}
                pdfUrl={'/images/monitor-login.png'} // Pass the PDF URL to the modal
            />
            }
        </>
        
        
    
    )
}


